import PhishingUseCaseIllustration from 'images/organization/features/malware/phising-use-case.svg'
import ProtectFinancialLossIllustration from 'images/organization/features/malware/protect-financial-loss.svg'
import EnsureProductivityIllustration from 'images/organization/features/malware/ensure-productivity.svg'
import MaintainSecurityIllustration from 'images/organization/features/malware/maintain-security.svg'
import { ElementType } from 'react'

interface MalwareUseCaseItem {
  image: ElementType
  title: string
  text: string
}

export const serviceFilteringUseCasesData: MalwareUseCaseItem[] = [
  {
    image: PhishingUseCaseIllustration,
    title: 'Enhanced productivity',
    text: 'Block distracting services such as social media or streaming apps to keep employees focused on business-critical tasks and enhance productivity.\n',
  },
  {
    image: ProtectFinancialLossIllustration,
    title: 'Tailored security solutions',
    text: 'Control D allows you to tailor web filtering to suit the unique needs of your organization, enabling you to block specific services that might pose a security risk or reduce productivity.',
  },
  {
    image: EnsureProductivityIllustration,
    title: 'Prevent unwanted service use',
    text: 'Gain control over web traffic by restricting the use of specific online services and applications. This helps protect sensitive company data and prevents unauthorized access to potentially harmful or risky services.',
  },
  {
    image: MaintainSecurityIllustration,
    title: 'Meet compliance standards',
    text: `Control D helps you enforce acceptable use policies and meet regulatory compliance by blocking or allowing specific services. This ensures your company adheres to data protection standards and minimizes unnecessary risks.
`,
  },
]

export default serviceFilteringUseCasesData
